export default "__VITE_ASSET__BXpMSa6I__"